<template>
    <SubPageHeader />
    <ImageGallery
        :images="images"
        class="mt-40"
    />
    <PageFooter />
</template>

<script>
import SubPageHeader from '../components/SubPageHeader.vue'
import ImageGallery from '../components/ImageGallery.vue'
import PageFooter from '../components/PageFooter.vue';

export default {
    name: 'App',
    components: {
        SubPageHeader,
        ImageGallery,
        PageFooter,
    },
    data() {
        return {
            images: [
                '0234_ustsqn',
                '0237_tbjp3p',
                '0233_vo5ho3',
                '0232_kisgrk',
                '0235_s3to4n',
                '0230_rvscxc',
                '0231_t7nvff',
                '0229_jnn2dw',
                '0227_f5sazf',
                '0226_bob8qw',
                '0228_bad2ve',
                '0225_rimqdf',
                '0223_x207cj',
                '0224_f14gnp',
                '0220_pgshxv',
                '0222_uucsh9',
                '0221_hduqhc',
                '0219_qhfhw2',
                '0217_wkxbjk',
                '0218_zvemmh',
                '0216_ghotzs',
                '0214_wvnfyt',
                '0215_f6orlj',
                '0213_sbzte6',
                '0212_loc73n',
                '0211_pqhszi',
                '0210_tuesao',
                '0209_temnno',
                '0208_s6i0m1',
                '0207_apuprh',
                '0206_uiooae',
                '0194_lo0pyp',
                '0205_m3jhc3',
                '0204_hr1pz5',
                '0202_rq6phm',
                '0203_zjgg1b',
                '0201_azt1pn',
                '0200_vnyvrs',
                '0184_mkmjz8',
                '0199_eizs3e',
                '0198_uhrqiy',
                '0197_xu1wof',
                '0196_dbazbj',
                '0195_aq8nl8',
                '0193_o2kr3o',
                '0182_jyi3qy',
                '0183_hulhhv',
                '0191_gde0kx',
                '0192_clj0e3',
                '0188_iy3tcm',
                '0190_mvod14',
                '0189_mixvg0',
                '0186_ytkh7f',
                '0187_im6ui0',
                '0176_alazga',
                '0175_n6j6jr',
                '0185_uhqlm9',
                '0180_nvhcf1',
                '0181_nv4h1o',
                '0179_cukzci',
                '0172_tufeu7',
                '0178_umktum',
                '0167_appni5',
                '0168_oyzjeh',
                '0177_qejmmp',
                '0174_a202mu',
                '0173_xyig7a',
                '0171_xvn4qu',
                '0159_eanklo',
                '0170_z8fxc0',
                '0169_ixhmyk',
                '0166_aysirc',
                '0164_b2peze',
                '0165_cfb9hm',
                '0162_f8yqrd',
                '0163_rkdepj',
                '0161_znqkzy',
                '0160_x1fkq1',
                '0158_dwc2yb',
                '0155_fgmbmv',
                '0157_wql84q',
                '0152_bzu7kg',
                '0156_grzmbk',
                '0154_etv0ug',
                '0135_rrpuem',
                '0153_dvfvwk',
                '0149_uxp9xz',
                '0150_atncmm',
                '0151_jh0wgt',
                '0148_olta8z',
                '0144_ntfbxt',
                '0145_azlpma',
                '0143_wsszqf',
                '0147_xdjdi0',
                '0141_iup9qc',
                '0146_g33lmr',
                '0134_mueybj',
                '0142_lrpoja',
                '0137_r3bqni',
                '0140_zn82uw',
                '0129_juswsg',
                '0139_fkxjer',
                '0138_stczqq',
                '0131_y5ai0p',
                '0136_ey2fce',
                '0133_uk0qk4',
                '0132_blcmqi',
                '0130_rsc9h7',
                '0125_gfqgnq',
                '0128_vpzcu4',
                '0127_euqo5g',
                '0124_a4ch6q',
                '0126_gf2wpu',
                '0119_joxzsk',
                '0123_nnihlb',
                '0122_ap6i5c',
                '0118_e2zflq',
                '0120_g8p5ov',
                '0121_cuvjsr',
                '0117_cdqlri',
                '0116_pdcse2',
                '0110_owzl5o',
                '0115_qfgsiv',
                '0108_i9tud7',
                '0114_tmxpel',
                '0112_fduvet',
                '0113_rlbtcx',
                '0107_lzzyjp',
                '0111_uxomdc',
                '0109_nf0cbg',
                '0094_jikwi3',
                '0106_lcsjcl',
                '0105_gdpxds',
                '0093_tuexhm',
                '0097_jgxpif',
                '0104_j2lznk',
                '0096_figunh',
                '0095_i2ny43',
                '0103_inqeox',
                '0102_j2dbvn',
                '0101_e6ahyn',
                '0100_sknhob',
                '0099_kbaajh',
                '0098_zuvz9y',
                '0092_qx7xlx',
                '0091_oyi1uc',
                '0089_gwlzrl',
                '0088_ii6hnl',
                '0090_upkynt',
                '0087_w69cth',
                '0085_rg1hgx',
                '0086_sfsikk',
                '0084_rwxfvk',
                '0083_ptofst',
                '0081_nt2wb8',
                '0080_nj70le',
                '0082_u9vodz',
                '0079_abu51j',
                '0077_ni8ljr',
                '0078_fcpojv',
                '0074_avldjr',
                '0076_ewuppy',
                '0075_pfnsgo',
                '0071_izeni2',
                '0066_qq2iel',
                '0072_wr1uql',
                '0073_vnkdmq',
                '0070_wvpl74',
                '0067_bdfevh',
                '0069_mfunvo',
                '0068_jm2fla',
                '0061_jobtzm',
                '0064_fo2bpo',
                '0065_m7o8fz',
                '0062_noaaw6',
                '0063_fidmuv',
                '0060_cvc6nh',
                '0059_ruodrn',
                '0055_jrwoq2',
                '0056_jvbbzg',
                '0054_xyza8a',
                '0058_ilyoea',
                '0057_a6sdu0',
                '0053_krb7ui',
                '0049_dha82c',
                '0052_trp64i',
                '0051_o1zjgb',
                '0050_xwq267',
                '0048_cd2w83',
                '0047_kl2wji',
                '0044_bya2p0',
                '0043_atm14q',
                '0042_h8mmak',
                '0045_m5wdkk',
                '0046_hun8th',
                '0041_halbsi',
                '0039_occf7r',
                '0040_pppqhq',
                '0037_l2crmm',
                '0036_fzfvh8',
                '0038_lkykmp',
                '0035_nrjbll',
                '0034_hak5z9',
                '0032_bpsk3b',
                '0031_cznnb9',
                '0033_udmusl',
                '0027_tnuw5s',
                '0030_mnoqzy',
                '0029_ocwazd',
                '0021_lxf7zs',
                '0026_pwlc0f',
                '0028_u19yds',
                '0016_pqujhq',
                '0025_mjrb91',
                '0024_kgw9mt',
                '0023_pkujxn',
                '0022_ytlv0z',
                '0009_x1f4vb',
                '0019_eyezxj',
                '0020_ecoocc',
                '0010_houytc',
                '0018_xrntdm',
                '0017_qljgu3',
                '0015_fnrnam',
                '0008_mz3cnk',
                '0007_hqtcjw',
                '0004_hjvme4',
                '0014_b1lvh4',
                '0013_l2jpjd',
                '0006_hfddsn',
                '0012_mlhvhk',
                '0003_v6pwz4',
                '0005_g8ggob',
                '0002_ctglb2',
                '0001_lsfg4g',
                '0011_in5otg'
            ]
        }
    }
}
</script>